import { Component, EventEmitter, Input, Output, OnInit, inject } from '@angular/core';
import { PatientAttachment } from '../../../core/models/patient-attachment.model';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { PatientAttachmentsService } from '../../../core/services/patient-attachments.service';
import { environment } from '../../../../environments/environment';
import { NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-consult-note-validator',
    templateUrl: './consult-note-validator.component.html',
    styleUrls: ['./consult-note-validator.component.scss'],
    imports: [NgClass, FaIconComponent]
})
export class ConsultNoteValidatorComponent implements OnInit {
  private patientAttachmentsService = inject(PatientAttachmentsService);
  private authService = inject(AuthenticationService);

  _patientAttachment: PatientAttachment;

  @Output() markedAsInvalidChanged = new EventEmitter<PatientAttachment>();

  markingAsInvalid = false;
  markAsInvalidDisabled = false;
  usePdfKitViewer: boolean;

  get patientAttachment(): PatientAttachment {
    return this._patientAttachment;
  }

  @Input()
  set patientAttachment(pa: PatientAttachment) {
    this._patientAttachment = pa;
    this.markAsInvalidDisabled = this.patientAttachment.hasVerifiedCapture;
  }

  onMarkAsInvalidClick($event) {
    $event.preventDefault();
    this.markingAsInvalid = true;
    const invalid = !this.patientAttachment.markedAsInvalid;

    this.patientAttachmentsService.markAsInvalid(this.patientAttachment.id, invalid, true).subscribe(
      pa => {
        this.markedAsInvalidChanged.emit(pa);
        this.markingAsInvalid = false;
      },
      () => {
        this.markingAsInvalid = false;
      }
    );
  }

  ngOnInit() {
    this.usePdfKitViewer = environment.featureData?.usePdfKitViewer && this.authService.isCaptureAdminUser;
  }
}
